module.exports = __webpack_public_path__ + "img/4.d5c16f52.png";